<template>
  <div>
    <div class="flex" data-test-id="enquiry-form-manager-avatar-container">
      <div class="h-16 mr-4">
        <img
          v-if="managerPhoto"
          width="70"
          height="70"
          :src="managerPhoto"
          :alt="manager.shortName"
          class="rounded-full border border-solid border-grey-300"
        >
        <UserAvatar
          v-else-if="manager.initials"
          :initial="manager.initials"
          :alt="manager.shortName"
          color="dark-green"
          size="large"
        />
        <PlaceholderPhoto v-else />
      </div>

      <div class="flex flex-col justify-center" ref="container">
        <div class="flex flex-wrap items-center">
          <div class="font-semibold text-init mr-2 mb-1">
            {{ manager.shortName }}
          </div>
          <SupervenueBadge
            v-if="venue.isSuperVenue"
            class="mb-1"
          />
        </div>

        <ActiveTimeAgoLabel ref="activeTimeAgoLabel" v-if="activeTimeAgoLabelEnabled" :value="$store.state.managerLastActivityOnline" data-test-id="enquiry-form-active-time-ago-label" />
        <div v-else class="text-grey-600 text-xs mt-1">
          Your Personal Event Manager from {{ venue.name }}
        </div>
      </div>
    </div>

    <div v-if="!$store.state.user.lastEnquiry.date && !$store.state.leadHubOffer && showResponseTime && ((responseRate && responseRate >= 75) || responseTime)"
      data-test-id="enquiry-form-response-stats"
      class="text-grey-800 text-sm leading-4 mt-4"
      :class="(!$store.getters.isRtbFlowPossible && $store.state.step === $store.state.STEPS.dateAndPeople ? 'im:-mb-2' : 'mb-4')"
    >
      <div v-if="responseRate && responseRate >= 75" class="flex items-center my-2">
        <ChartIcon class="w-4 h-4 mr-1" />Response rate - {{ responseRate }}%
      </div>
      <div v-if="responseTime" class="flex items-center my-2">
        <ClockIcon class="w-4 h-4 mr-1" /> Response time - {{ responseTime }}
      </div>
    </div>
  </div>
</template>

<script>
import ChartIcon from '@tagvenue/icons/24/line/charts/bar-chart-square-02.svg';
import ClockIcon from '@tagvenue/icons/24/line/time/clock.svg';
import { mapState } from 'vuex';

import ActiveTimeAgoLabel from '@/components/Ui/ActiveTimeAgoLabel.vue';
import UserAvatar from '@/components/Ui/UserAvatar.vue';
import { formatResponseTime } from '@/services/response-time-formatter';

import PlaceholderPhoto from './PlaceholderPhoto.vue';
import SupervenueBadge from './SupervenueBadge.vue';

export default {
  name: 'EnquiryFormHeader',
  components: { ActiveTimeAgoLabel, SupervenueBadge, PlaceholderPhoto, UserAvatar, ChartIcon, ClockIcon },
  props: {
    showResponseTime: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  computed: {
    ...mapState([
      'manager',
      'venue',
    ]),
    activeTimeAgoLabelEnabled() {
      return this.$store.state.managerLastActivityOnline !== null && this.$store.state.managerLastActivityOnline < 6 * 60;
    },
    responseTime() {
      const responseTime = this.$store.state.responseTime;
      return formatResponseTime(responseTime);
    },
    responseRate() {
      return Math.ceil(this.$store.state.responseRate * 100);
    },
    managerPhoto() {
      return this.manager.photo;
    },
  },
};
</script>
